module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"cancel":"Отменить изменения","accept":"Принять","reject":"Отклонить","go-to-user":"Перейти к редактированию"},"en":{"cancel":"Cancel changes","accept":"Accept","reject":"Reject","go-to-user":"Go to edit"}}')
  delete Component.options._Ctor
}
